import { useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import { FiCopy, FiEdit } from "react-icons/fi";
import { MdOutlineEdit } from "react-icons/md";
import ActionMenu from "../../../component/ActionMenu";
import { IoIosAddCircle } from "react-icons/io";
import { IoCheckmarkSharp, IoClose, IoCloseSharp } from "react-icons/io5";
import AddStudentBusFeeModel from "../../../component/Model/AddStudentBusFeeModel";
import CreateModal from "../../../component/Model/CreateModel";
import AdminPagination from "../../../component/pagination/AdminPagination";
import SkeletonLoading from "../../../component/SkeletonLoading";

import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Tooltip from "../../../component/Tooltip";
import i18n from "../../../i8next";
import {
  useChangeStatusMutation,
  // useDeleteRecordMutation,
  useGetBusFeeCofigQuery,
} from "../../../store/api/configurationSlice";
import { capitalizeString } from "../../../utils/dateAndTimeConversion";

const BusFee = () => {
  const { t } = useTranslation();
  const { slug } = useParams();
  const { user } = useSelector((state) => state.UserReducer);
  const [showModel, setShowModel] = useState(false);
  const [show, setShow] = useState(false);
  const [id, setId] = useState("");
  const [editData, setEditData] = useState(null);
  const [busFees, setBusFees] = useState([]);
  const [show2, setShow2] = useState(false);
  const copyData = useRef();

  const [search, setSearch] = useState("");

  const [pagination, setPagination] = useState({
    limit: 10,
    page: 1,
    search: "",
  });

  const isAdmin = user?.role === "super_admin";
  // slug base fetch data
  const userRole =
    slug === "school-bus-fee"
      ? "school"
      : slug === "vendor-bus-fee"
        ? "vendor"
        : null;

  // GET ALL STUDENT FEE API FOR (SUPER ADMIN | SCHOOL | VENDOR)
  const { data, isLoading, isFetching, isSuccess, refetch } =
    useGetBusFeeCofigQuery({
      page: pagination.page,
      limit: pagination.limit,
      search: pagination.search,
      role: userRole,
    });

  // Update Student FEE Status
  const [changeStatus, { isLoading: isUpdateLoading }] =
    useChangeStatusMutation();

  // When data is fetched, update the filtered data
  useEffect(() => {
    if (isSuccess && data?.data) {
      setBusFees(data?.data?.data);
      setPagination((prev) => ({
        ...data?.data?.pagination,
        search: prev.search,
      }));
    }
  }, [data, isSuccess]);

  // Update Student FEE Status Active | In Active FOR (SUPER ADMIN | SCHOOL | VENDOR)
  const handleActiveBusFee = async (data) => {
    setId(data.id);
    toast.dismiss();

    const { id, is_active } = data;
    const payload = {
      id: data.id,
      is_active: data.is_active === 1 ? false : true,
    };

    try {
      let res = await changeStatus(payload).unwrap();

      if (res.statusCode === 200 || res.statusCode === 201) {
        toast.success(res.message);
      }
    } catch (err) {
      toast.error(err?.data?.message || "Something went wrong");
    }
  };

  // show edit model
  const handleEdit = (data) => {
    setEditData(data);
    setShowModel(true);
  };

  const handleClose = () => {
    setShow2(false);
    setEditData(null);
  };

  const handlePageChange = (page) => {
    setPagination((prev) => ({ ...prev, page }));
  };

  const handleLimitChange = (limit) => {
    setPagination((prev) => ({
      ...prev,
      limit,
      page: 1,
    }));
  };

  const handleSearch = () => {
    setPagination((prev) => ({
      ...prev,
      page: 1,
      search: search.trim(),
    }));
  };

  // handle row copy
  const handleCopy = (row) => {
    copyData.current = {
      country_name: row.country_name,
      child_type: row.child_type,
      service_type: row.service_type,
      fee: row.fee,
    };
    setEditData(null);
    setShowModel(true);
  };

  useEffect(() => {
    if (!search.trim()) {
      setPagination((prev) => ({
        ...prev,
        search: "",
      }));
    }
  }, [search]);

  // Change Language Handler
  useEffect(() => {
    const h = () => {
      refetch?.();
    };
    i18n.on("languageChanged", h);
    return () => i18n.off("languageChanged", h);
  }, [refetch]);

  return (
    <>
      <div className="d-flex justify-content-between align-items-center flex-wrap w-100 mb-2">
        <div className="total">
          {t("total")}: {pagination.total}
        </div>

        <div className="d-flex flex-wrap gap-2">
          <div className="d-flex flex-grow-1">
            <input
              type="text"
              className="form-control custom-field-one"
              placeholder={`${t("search")}..`}
              value={search}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch();
                }
              }}
              onChange={(e) => setSearch(e.target.value.trim())}
            />
          </div>
          <div className="d-flex gap-2 flex-grow-1">
            <button
              className="btn btn-primary flex-grow-1"
              onClick={handleSearch}
            >
              {t("search")}
            </button>
            {!isAdmin && (
              <Button
                className="d-flex align-items-center gap-1 flex-grow-1 justify-content-center"
                onClick={() => setShowModel(true)}
              >
                <IoIosAddCircle size={15} fill="white" />
                {t("add")}
              </Button>
            )}
          </div>
        </div>
      </div>

      <AddStudentBusFeeModel
        show={showModel}
        onHide={() => {
          setShowModel(false);
          setEditData(null);
          copyData.current = null;
        }}
        copyData={copyData.current}
        editData={editData}
        onSuccess={() => setShow2(true)}
      />

      <div className="table m-0">
        <table>
          <thead>
            <tr>
              <th>
                {t("SR")}.{t("no")}.
              </th>
              <th>{t("country")}</th>
              <th>
                {t("child")} {t("type")}
              </th>
              <th>
                {t("service")} {t("type")}
              </th>{" "}
              <th>{t("fee")}</th>
              {user.role !== "super_admin" && (
                <th width="70px">{t("actions")}</th>
              )}
            </tr>
          </thead>
          <tbody>
            {isLoading || isFetching ? (
              <SkeletonLoading length={user.role === "super_admin" ? 5 : 6} />
            ) : busFees.length > 0 ? (
              busFees.map((item, i) => (
                <tr key={i}>
                  <td>{(pagination.page - 1) * pagination.limit + i + 1}</td>
                  <td>{item?.country_name}</td>
                  <td>{capitalizeString(item?.child_type)}</td>
                  <td>{t(item?.service_type)}</td>
                  <td>${item?.fee}</td>
                  {user.role !== "super_admin" && (
                    <td>
                      <ActionMenu
                        actions={[
                          {
                            label: t("Copy"),
                            icon: <FiCopy size={15} />,
                            onClick: () => handleCopy(item),
                          },
                          {
                            label: t("edit"),
                            icon: <MdOutlineEdit size={16} />,
                            onClick: () => handleEdit(item),
                          },
                          {
                            label: item.is_active
                              ? `${t("inactivate")}`
                              : `${t("activate")}`,
                            icon: item.is_active
                              ? <IoClose size={15} />
                              : <IoCheckmarkSharp size={15} />,
                            onClick: () => handleActiveBusFee(item),
                            disabled: isUpdateLoading,
                          },
                        ]}
                      />
                    </td>
                  )}
                </tr>
              ))
            ) : (
              <tr className="text-center">
                <td colSpan="6">
                  <div>
                    <span>
                      {" "}
                      {t("no")} {t("record")} {t("found")}
                    </span>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <AdminPagination
        totalPages={pagination.totalPages}
        currentPage={pagination.page}
        limit={pagination.limit}
        onPageChange={handlePageChange}
        onLimitChange={handleLimitChange}
      />

      {/* Delete Confirmation Modal */}
      {/* <Modal show={show}>
        <Button className="closePopup" onClick={() => setShow(false)}>
          <IoCloseSharp />
        </Button>
        <div className="popupBox p-3 p-md-5">
          <div>
            <div className="text-center mb-3 errorIcon">
              <BiSolidError />
            </div>
            <div className="text-center mb-4 deleteHd">
              {t("confirmDelete")}
            </div>
            <div className="text-center">
              <Button
                className="smallBtn cancel me-3"
                onClick={() => setShow(false)}
              >
                {t("btns.cancel")}
              </Button>
              <Button
                className="smallBtn auto"
                onClick={handleDelete}
                disabled={isDeleting}
              >
                {isDeleting ? (
                  <div className="spinner-border" role="status">
                    <span className="sr-only p-0"></span>
                  </div>
                ) : (
                  t("btns.delete")
                )}
              </Button>
            </div>
          </div>
        </div>
      </Modal> */}

      <Modal show={show2}>
        <Button className="closePopup" onClick={handleClose}>
          <IoCloseSharp />
        </Button>
        <CreateModal
          title={`Student Bus Fee ${editData ? t("updated") : t("added")} ${t(
            "successfully",
          )}!`}
          text={
            editData
              ? `${t("student")} ${t("bus")} ${t("fee")} ${t("has")} ${t(
                  "been",
                )} ${t("updated")}.`
              : `${t("student")} ${t("bus")} ${t("fee")} ${t("has")} ${t(
                  "been",
                )} ${t("added")}.`
          }
          onClose={handleClose}
        />
      </Modal>
    </>
  );
};

export default BusFee;
